<script setup lang="ts">
import CalendarHeaderWeekday from '@ui/components/calendar/picker/day/CalendarHeaderWeekday.vue'
import { getWeekdayName } from '@ui/utils/times'
import { addDays, eachDayOfInterval } from 'date-fns'

withDefaults(
  defineProps<{
    today?: Date
  }>(),
  {
    today: () => new Date(),
  },
)

const start = new Date(2024, 8, 2)
const days = eachDayOfInterval({ start, end: addDays(start, 6) })
</script>

<template lang="pug">
.flex.row-8
  CalendarHeaderWeekday(
    v-for="day of days"
    :key="day.getDate()"
    :label="getWeekdayName(day)"
    class="flex-1 min-w-0"
    :today="today.getDay() === day.getDay()"
  )
</template>
